import styled, { keyframes } from 'styled-components';

import Icon from '../Icon/Icon';

const animations = {
  rotate360: keyframes`
    0% {
      transform: rotate(0deg);
    }
    25% {
      transform: rotate(100deg);
    }
    75% {
      transform: rotate(210deg);
    }
    100% {
      transform: rotate(360deg);
    }
  `
};

const SpinnerIcon = styled(Icon).attrs({
  icon: 'spinner'
})`
  animation: ${animations.rotate360} 0.7s linear infinite;
`;

export default SpinnerIcon;



// WEBPACK FOOTER //
// ./src/components/units/Spinner/Spinner.js